export default {
  SET_INVOICES: 'SET_INVOICES',
  SET_RECEIPTS: 'SET_RECEIPTS',
  SET_PAYMENT_HISTORY: 'SET_PAYMENT_HISTORY',
  SET_PAYMENT_ERROR: 'SET_PAYMENT_ERROR',
  SET_PAYMENT_METHODS: 'SET_PAYMENT_METHODS',
  SET_AUTOPAY_SETTINGS: 'SET_AUTOPAY_SETTINGS',
  SET_IS_PAYMENT_MODAL_OPEN: 'SET_IS_PAYMENT_MODAL_OPEN'
};
